<script>
    import Design2021ApprenticeDataTable from '../../../common/design-2021-apprentice-data-table.vue';

    export default {
        name: 'design-2021-lesson-module-types-modal',
        components: { Design2021ApprenticeDataTable },
        props: {
            lessonModuleTypesIn: {
                type: Array
            }
        },
        data() {
            return {
                hasError: false,
                display: false,
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$t('common.actions')
                    }
                ],
                types: this.lessonModuleTypesIn,
                errorIds: []
            };
        },
        methods: {
            show() {
                this.display = true;
            },
            storeTypes(bvModalEvent) {
                if (this.hasErrors()) {
                    bvModalEvent.preventDefault();
                    return;
                }

                let data = {
                    types: this.types
                };
                this.alert.saving();
                this.axios.post(this.routes.lessonModuleTypes(), data).then(
                    (response) => {
                        this.types = response.data;
                        this.$emit('types-updated', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },
            removeType(index) {
                this.types.splice(index, 1);
            },
            addType() {
                this.types.push({
                    name: ''
                });
            },
            hasErrors() {
                let errorsFound = false;
                this.hasError = false;
                this.errorIds = [];
                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].name === '') {
                        errorsFound = true;
                        this.hasError = true;
                        this.errorIds.push(i);
                    }
                }

                return errorsFound;
            }
        }
    };
</script>

<template>
    <b-modal
        id="lesson-module-types-modal"
        modal-class="apprentice-default-modal"
        :title="$t('lesson_module.lesson_module_types')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        v-model="display"
        @ok="storeTypes"
        size="md">
        <div class="types-management">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ $t('lesson_module.not_all_types_filled_in_correctly_name_is_mandatory') }}
            </b-alert>
            <div class="types-overview">
                <design2021-apprentice-data-table
                    class="tags-overview-table"
                    :fields="fields"
                    :items="types">
                    <template #cell(name)="row">
                        <div
                            class="name"
                            :class="row.item.name === '' && 'empty'">
                            <b-form-input
                                v-model="row.item.name"
                                :id="`new-lesson-module-type-input-${row.index}`"
                                :key="`new-lesson-module-type-input-${row.index}`"
                                :placeholder="$t('common.name')">
                            </b-form-input>
                        </div>
                    </template>

                    <template #cell(action)="row">
                        <div
                            class="actions">
                            <b-button
                                class="btn-remove btn-remove-type"
                                variant="danger-icon-only"
                                @click="removeType(row.index)">
                            </b-button>
                        </div>
                    </template>
                </design2021-apprentice-data-table>

                <div class="add-type">
                    <b-button
                        class="btn-add btn-add-lesson-module-type"
                        variant="primary"
                        @click="addType">
                        {{ $t('lesson_module.add_type') }}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style scoped lang="scss">

</style>